// Conditional follow-ups on single-choice questions (shared by Survey Builder,
// respondent form and Response Detail). Config lives on the question as
// `option_followups: [{ option, label, field_type, required, min_value, max_value, choices }]`.

export const FOLLOWUP_FIELD_TYPES = [
  ['number', 'Number'],
  ['short_text', 'Short text'],
  ['dropdown', 'Dropdown'],
];

const norm = (s) => String(s ?? '').trim().toLowerCase();
export const sameOption = (a, b) => norm(a) === norm(b);
export const optionLabel = (o) => (typeof o === 'string' ? o : o?.label || '').trim();
export const isBlank = (v) => v == null || String(v).trim() === '';

export function selectedLabel(ans) {
  if (typeof ans === 'string') return ans;
  if (ans && typeof ans === 'object') return typeof ans.label === 'string' ? ans.label : (typeof ans.value === 'string' ? ans.value : '');
  return '';
}

export function followupFor(question, answer) {
  const cfgs = question?.type === 'single_choice' ? question.option_followups : null;
  if (!Array.isArray(cfgs) || !cfgs.length) return null;
  const sel = selectedLabel(answer);
  return sel ? cfgs.find((c) => sameOption(c.option, sel)) || null : null;
}

export function followupError(cfg, v) {
  if (!cfg) return null;
  if (isBlank(v)) return cfg.required ? 'required' : null;
  if (cfg.field_type === 'number') {
    const n = Number(v);
    const lo = cfg.min_value, hi = cfg.max_value;
    if (!Number.isFinite(n)) return 'Please enter a number.';
    if ((lo != null && n < lo) || (hi != null && n > hi)) {
      if (hi == null) return `Please enter a number of at least ${lo}.`;
      if (lo == null) return `Please enter a number no higher than ${hi}.`;
      return `Please enter a number between ${lo} and ${hi}.`;
    }
  }
  if (cfg.field_type === 'dropdown' && !(cfg.choices || []).includes(v)) return 'Please choose an option.';
  return null;
}

export const isFollowupValid = (cfg, v) => !followupError(cfg, v);

// Keep follow-ups attached when answer options are renamed (same position)
// and drop follow-ups whose option was removed.
export function remapFollowups(oldOpts, newOpts, followups) {
  if (!Array.isArray(followups) || !followups.length) return followups;
  const oldL = (oldOpts || []).map(optionLabel);
  const newL = (newOpts || []).map(optionLabel);
  return followups.map((f) => {
    if (newL.some((l) => sameOption(l, f.option))) return f;
    const i = oldL.findIndex((l) => sameOption(l, f.option));
    return i >= 0 && oldL.length === newL.length && newL[i] ? { ...f, option: newL[i] } : null;
  }).filter(Boolean);
}

export function formatFollowupValue(fu) {
  if (!fu || isBlank(fu.value)) return '';
  return String(fu.value);
}
